<template>
  <div class="home-page">
    <div class="">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="40" src="../../static/images/back2.png"/>
        </div>
        <div class="title-bg">{{ $t('Profile') }}</div>
      </div>
    </div>
    <div class="info">

      <div class="at-img ac por">
        <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*">
        <img class="account-img" :src="info.avatar"/>
      </div>
      <div class="account-content">
        <div class="ac">
          <div v-if="isEdit" class="flex" style="margin:20px 0;">
            <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;" v-model="nickname"/>
            <button class="button" style="width: 30%;padding: 14px 20px;" @click="editSub">{{ $t('Submit') }}</button>
          </div>
          <div v-else>
            <span class="name-span app-en">{{ info.nickname }}</span>
            <span class=" crff1d4f fs33" @click="editName">
                <img width="30" class="edit" src="static/images/edit.png"/>
              </span>
          </div>
        </div>
        <div class="change-list2 mt50 crfff ac por">
          <div class="fs27 pt20">{{ $t('language') }}</div>
          <div class="change-list ac">
            <div class="one" @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
              <img class="dui"
                   :src="isShowLang=='bur'?'../../static/images/selected.png':'../../static/images/select.png'">
              <span>{{ $t('Myanmar') }}</span>
            </div>
            <div class="one" @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
              <img class="dui"
                   :src="isShowLang=='en'?'../../static/images/selected.png':'../../static/images/select.png'">
              <span>{{ $t('English') }}</span>
            </div>
          </div>
        </div>
        <div class="change-list2 mt30 crfff ac por" >
          <div class="share-panel mt30" style="margin-bottom: 30px;">
            <div class="share-panel-title">{{ $t('sharePanelTitle') }}</div>
            <div class="share-panel-tips">{{ $t('sharePanelTips') }}</div>
            <div class="share-grid mt20">
              <button
                v-for="item in sharePlatforms"
                :key="item.type"
                class="share-card"
                @click="shareTo(item.type)"
              >
                <span class="share-icon"><img :src="getShareIconSrc(item.type)" :alt="item.labelKey"></span>
                <span class="share-label">{{ item.labelKey }}</span>
              </button>
            </div>
            <div class="share-actions-row mt20">
              <button class="share-more-button" v-if="canUseNativeShare" @click="shareTo('native')">
                <span class="share-more-icon">+</span>
                <span>{{ $t('shareMore') }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="ac mt50">
          <button class="button guidance" @click="guidance">
            <span class="icon"><img src="../../static/images/i.png"></span>
            <span class="text-shadow">{{ $t('guidance') }}</span>
            <img style="transform: rotate(-90deg);" src="../../static/images/up.png">
          </button>
        </div>
        <div class="ac mt50">
          <button style="width: 350px" class="button unSubscribe" @click="unSubscribe">{{ $t('Unsucscribe') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import Clipboard from 'clipboard';

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      disAbled: '',
      isEdit: false,
      info: {},
      nickname: '',
      base64Image: '',
      lang: '',
      isShowLang: 'bur',
      allPlatforms: [
        {type: 'whatsapp', labelKey: 'Whatsapp'},
        {type: 'telegram', labelKey: 'Telegram'},
        {type: 'line', labelKey: 'LINE'},
        {type: 'messenger', labelKey: 'Messenger'},
        {type: 'viber', labelKey: 'Viber'},
      ]
    }
  },
  mounted() {
    let that = this;
  },
  created() {

    if (localStorage.getItem('lang')) {
      this.isShowLang = localStorage.getItem('lang')
    }
    this.getHome();

  },
  computed: {
    canUseNativeShare() {
      return !!navigator.share;
    },
    iosOnlyPlatforms() {
      return [{type: 'whatsapp', labelKey: 'Whatsapp'}];
    },
    sharePlatforms() {
      var ua = navigator.userAgent || '';
      var isIOS = /iphone|ipad|ipod/i.test(ua);
      if (isIOS) {
        return this.iosOnlyPlatforms;
      }
      return this.allPlatforms;
    },
  },
  methods: {
    reRating() {
      this.$router.push({path: '/leveltest'});
    },
    guidance() {
      this.$router.push({path: '/guidance'});
    },
    getLang(type, lang) {
      if (type == 2) {
        this.isShowLang = lang
        this.lang = lang
        localStorage.setItem('lang', this.lang)
        location.reload()
      } else {
      }
    },
    handleFileUpload(event) {
      let that = this;
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log(e);
          this.base64Image = e.target.result;

          // 从Base64字符串中提取图片类型
          const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
          const type = matches ? matches[1] : '';

          that.uploadImage(type);
        };
        reader.readAsDataURL(file);
      }
    },

    async uploadImage(imageType) {
      let that = this
      if (!this.base64Image) {
        that.$utils.alertText('pls select picture', 80);
        return;
      }
      try {
        let data = {
          image: {
            "content": this.base64Image,
            "type": imageType || "" // 使用提取的类型，如果没有则留空
          }
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/upload_avatar', data, r => {
          that.$parent.returnCode(r, function () {
            that.$utils.alertText(r.msg, 80);
            that.getHome()
            that.$parent.loadModal(false);
          });
        })
      } catch (error) {
        that.$utils.alertText(r.msg, 80);
      }
    },
    back() {
      this.$router.go(-1);
    },
    editName() {
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub() {
      let that = this;
      let data = {
        nickname: that.nickname
      }
      that.$api.post('/api/user/profile', data, r => {
        that.$parent.returnCode(r, function () {
          //that.info = r.data
          that.isEdit = false
          that.getHome()
          that.$parent.loadModal(false);
        });

      })
    },
    getHome() {
      let that = this;
      that.$api.post('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.info = r.data
          localStorage.setItem('avatar', r.data.avatar)
          that.$parent.loadModal(false);
        });

      })
    },

    unSubscribe() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('api/user/unsubscribe', null, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 80);
          localStorage.removeItem('token')
          localStorage.removeItem('mobile')
          // that.$router.push({path:'/login'});
          window.location.href = that.$chinUrl + 'login';
        });
      })
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getShareIconSrc(type) {
      return 'static/images/logo/' + type + '.png';
    },
    isAndroidDevice() {
      return /android/i.test(navigator.userAgent || '');
    },
    getShareTarget(type) {
      const url = this.info.invite_url;
      const text = this.$t('referralTips1').replace(/<[^>]*>/g, '');
      const encodedUrl = encodeURIComponent(url);
      const encodedText = encodeURIComponent(text);
      const encodedMessage = encodeURIComponent(text + '\n' + url);
      const targets = {
        whatsapp: {
          intentUrl: 'intent://send/?text=' + encodedMessage + '#Intent;scheme=whatsapp;package=com.whatsapp;end',
          schemeUrl: 'whatsapp://send?text=' + encodedMessage,
          webUrl: 'https://wa.me/?text=' + encodedMessage,
        },
        telegram: {
          intentUrl: 'intent://msg_url?url=' + encodedUrl + '&text=' + encodedText + '#Intent;scheme=tg;package=org.telegram.messenger;end',
          schemeUrl: 'tg://msg_url?url=' + encodedUrl + '&text=' + encodedText,
          webUrl: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + encodedText,
        },
        line: {
          intentUrl: 'intent://msg/text/' + encodedMessage + '#Intent;scheme=line;package=jp.naver.line.android;end',
          schemeUrl: 'line://msg/text/' + encodedMessage,
          webUrl: 'https://social-plugins.line.me/lineit/share?url=' + encodedUrl,
        },
        messenger: {
          intentUrl: 'intent://share?link=' + encodedUrl + '#Intent;scheme=fb-messenger;package=com.facebook.orca;end',
          schemeUrl: 'fb-messenger://share?link=' + encodedUrl,
          webUrl: 'https://www.facebook.com/dialog/send?link=' + encodedUrl + '&app_id=291494419107518&redirect_uri=' + encodedUrl,
        },
        viber: {
          intentUrl: 'intent://forward?text=' + encodedMessage + '#Intent;scheme=viber;package=com.viber.voip;end',
          schemeUrl: 'viber://forward?text=' + encodedMessage,
          webUrl: 'viber://forward?text=' + encodedMessage,
        },
      };
      return targets[type] || {};
    },
    openShareLink(url) {
      var popup = window.open(url, '_blank', 'noopener=yes,noreferrer=yes');
      if (popup) {
        popup.opener = null;
      } else {
        window.location.href = url;
      }
    },
    launchWithFallback(intentUrl, schemeUrl) {
      var hidden = false;
      var resolved = false;
      var that = this;
      var cleanup = function () {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', onPageHide);
      };
      var finish = function (result) {
        if (resolved) return;
        resolved = true;
        cleanup();
        return result;
      };
      var onVisibilityChange = function () {
        if (document.hidden) {
          hidden = true;
          finish(true);
        }
      };
      var onPageHide = function () {
        hidden = true;
        finish(true);
      };
      document.addEventListener('visibilitychange', onVisibilityChange);
      window.addEventListener('pagehide', onPageHide);
      if (intentUrl && schemeUrl) {
        window.location.href = intentUrl;
        setTimeout(function () {
          if (!hidden) {
            window.location.href = schemeUrl;
          }
        }, 250);
      } else if (intentUrl) {
        window.location.href = intentUrl;
      } else if (schemeUrl) {
        window.location.href = schemeUrl;
      }
      setTimeout(function () {
        if (!hidden) {
          finish(false);
        }
      }, 1400);
    },
    shareTo(type) {
      if (!this.info.invite_url) {
        this.$utils.alertText(this.$t('CopySucceeded'));
        return;
      }
      if (type === 'native') {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: this.$t('referralTips1').replace(/<[^>]*>/g, ''),
            url: this.info.invite_url,
          });
        }
        return;
      }
      var target = this.getShareTarget(type);
      var isAndroid = this.isAndroidDevice();
      if (isAndroid && (target.intentUrl || target.schemeUrl)) {
        this.launchWithFallback(target.intentUrl, target.schemeUrl);
        return;
      }
      if (target.webUrl) {
        this.openShareLink(target.webUrl);
      }
    },
  }
}
</script>
<style scoped>
.share-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 249, 255, 0.96) 100%);
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 28px;
  padding: 44px 32px 36px;
  margin: 0 30px;
  box-shadow: 0 8px 30px rgba(13, 14, 49, 0.12);
  backdrop-filter: blur(4px);
}

.share-panel-title {
  font-size: 38px;
  font-weight: 700;
  color: #0d0e31;
  text-align: center;
  margin-bottom: 12px;
}

.share-panel-tips {
  font-size: 23px;
  color: #6c7288;
  text-align: center;
  line-height: 1.45;
  margin-bottom: 8px;
}

.share-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  justify-content: center;
}

.share-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  min-height: 148px;
  padding: 25px 12px;
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f6f7fc 100%);
  border: 1px solid rgba(112, 124, 178, 0.18);
  box-shadow: 0 4px 14px rgba(14, 20, 51, 0.06);
  cursor: pointer;
  transition: all 0.2s;
  color: #203366;
}

.share-card:last-child:nth-child(3n + 1) {
  grid-column: 2 / 3;
}


.share-card:only-child {
  grid-column: 2 / 3;
  justify-self: center;
}

.share-card:active {
  transform: scale(0.96);
  background: linear-gradient(180deg, #eef1fb 0%, #e8edf9 100%);
  box-shadow: 0 2px 8px rgba(14, 20, 51, 0.08);
}

.share-icon {
  width: 74px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 74px;
  border-radius: 50%;
  background: linear-gradient(180deg, #ffffff 0%, #f2f4fb 100%);
  box-shadow: inset 0 0 0 1px rgba(111, 124, 179, 0.1);
}

.share-icon img {
  width: 74%;
  height: 74%;
  object-fit: contain;
  display: block;
}

.share-label {
  font-size: 23px;
  font-weight: 700;
  white-space: nowrap;
  line-height: 1.1;
  color: #24345f;
}

.share-actions-row {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.share-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 22px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f7fd 100%);
  border: 1px dashed rgba(112, 124, 178, 0.42);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 24px;
  font-weight: 600;
  color: #5d6786;
}

.share-more-button:active {
  background: linear-gradient(180deg, #eef1fb 0%, #e8edf9 100%);
  transform: scale(0.98);
}

.share-more-icon {
  font-size: 32px;
  font-weight: 700;
  color: #0d0e31;
}
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue